// Initial values for the Edit declaration page and the PDF it renders.

const SD_PREFIX = 'SD';

// The form owns the shape; the declaration only fills the keys it actually carries.
const overlay = (base, declaration) =>
  Object.fromEntries(
    Object.entries(base).map(([key, seeded]) => {
      const stored = declaration?.[key];
      return [key, stored === '' || stored === null || stored === undefined ? seeded : stored];
    }),
  );

// TODO: supplier and recipient come from Company structure and Manage customers, not this DTO.
const buildSeedValues = (allocation) => ({
  idPrefix: SD_PREFIX,
  idNumber: '',
  dateOfIssuance: '',
  dateOfDispatch: allocation?.dateOfDispatchInput ?? '',

  supplierName: '',
  supplierAddress: '',
  supplierCertificateNumber: '',
  supplierDispatchAddress: '',
  dispatchSameAsSupplier: false,

  recipientName: allocation?.sendTo ?? '',
  recipientAddress: '',
  contractNumber: '',
  recipientReceiptAddress: '',
  receiptSameAsRecipient: false,

  // Carried from the inbound declaration; the allocation fixes only the quantity and unit.
  typeOfProduct: allocation?.materialName ?? '',
  rawMaterialType: allocation?.rawMaterialTypeCode ?? '',
  additionalInformation: '',
  countryOfOrigin: allocation?.countryOfOriginCode ?? '',
  totalCertifiedQuantity: allocation?.rawByUnit?.declaration ?? '',
  unit: allocation?.declarationUnit ?? '',
  energyContent: '',
  isccCompliantMaterial: '',
  euRedCompliantMaterial: '',
  chainOfCustodyOption: '',
  countryOfBiofuelProduction: '',
  startDateOfBiofuelProduction: '',
  startDateOfBioliquidUse: '',
  sustainabilityCriteriaCompliance: '',
  intermediateCrop: '',
  lowIlucRisk: '',
  wasteOrResidue: '',
  wastePermitNumber: '',
  supportReceived: '',
  supportNatureAndScheme: '',

  defaultValueApplied: '',
  totalGhgEmissions: allocation?.ghgEmissionsRaw ?? '',
  eec: '',
  el: '',
  ep: '',
  etd: '',
  eu: '',
  esca: '',
  eccs: '',
  eccr: '',
  allocatedHeat: '',
  allocatedElectricity: '',
  escaBonusCap: '',
  nuts2Area: '',
  savingTransport: '',
  savingElectricity: '',
  savingElectricityOutermost: '',
  savingUsefulHeat: '',
  savingHeatSubstitution: '',
  foodSecurityStandard: '',
  euDeforestationRegulation: '',
  nonGmoFoodFeed: '',
  nonGmoTechnicalMarkets: '',

  shippingDistanceKm: '',
  trainDistanceKm: '',
  roadDistanceKm: '',
  disaggregatedDefaultValueForOil: '',
  disaggregatedDefaultValueForSoil: '',
  elBonusObtained: '',
});

/** `declaration` is `allocationDeclaration(id)`; the allocation fills its gaps. */
export const buildEditDeclarationValues = (allocation, declaration) =>
  overlay(buildSeedValues(allocation), declaration);
